<template>
    <div dusk="onboarding-checklist" class="onboarding-bg position-relative p-2" v-if="visible">
        <header
            class="position-relative px-2 py-1 d-flex align-items-center justify-content-between cursor-pointer"
            @click="open = !open"
        >
            <h4
                class="text-white font-weight-bold onboarding-title"
                :class="{ 'onboarding-title-collapsed': !open }"
            >
                Onboarding Checklist
            </h4>
            <i v-if="open" class="text-white fa fa-times onboarding-close"></i>
            <i v-else="" class="text-white fa fa-plus onboarding-close"></i>
        </header>
        <transition name="simple-fade">
            <div v-if="open" class="position-absolute onboarding-bg p-2">
                <div class="bg-white">
                    <div class="onboarding-list-item mx-1 pt-3 d-flex align-items-start">
                        <span class="badge badge-pill badge-dark mr-2">1</span>
                        <div class="w-100">
                            <div
                                class="w-100 font-weight-bold text-capitalize d-flex justify-content-between mb-0"
                            >
                                <span
                                    :class="{ 'text-light green-strike': isStepDone('has_photo') }"
                                    >Upload your profile photo</span
                                >
                                <span
                                    v-if="isStepDone('has_photo')"
                                    class="ml-auto text-nowrap small text-success font-weight-bold text-uppercase"
                                >
                                    <i class="fa fa-fw fa-check-circle text-success"></i>
                                    Done
                                </span>
                            </div>
                            <span
                                @click="uploadPhoto()"
                                class="cursor-pointer font-weight-bold text-primary"
                                >Add your photo ></span
                            >
                        </div>
                    </div>

                    <div class="onboarding-list-item mx-1 mt-3 d-flex align-items-start">
                        <span class="badge badge-pill badge-dark mr-2">2</span>
                        <div class="w-100">
                            <div
                                class="w-100 font-weight-bold text-capitalize d-flex justify-content-between mb-0"
                            >
                                <span
                                    :class="{
                                        'text-light green-strike': isStepDone('has_clients'),
                                    }"
                                    >Create your client list</span
                                >
                                <span
                                    v-if="isStepDone('has_clients')"
                                    class="ml-auto text-nowrap small text-success font-weight-bold text-uppercase"
                                >
                                    <i class="fa fa-fw fa-check-circle text-success"></i>
                                    Done
                                </span>
                            </div>
                            <a href="/connections" class="font-weight-bold text-primary"
                                >Add a few clients ></a
                            >
                        </div>
                    </div>

                    <div class="onboarding-list-item mx-1 mt-3 d-flex align-items-start">
                        <span class="badge badge-pill badge-dark mr-2">3</span>
                        <div class="w-100">
                            <div
                                class="w-100 font-weight-bold text-capitalize d-flex justify-content-between mb-0"
                            >
                                <span
                                    :class="{
                                        'text-light green-strike': isStepDone('has_goals'),
                                        'text-light': !isStepDone('has_clients'),
                                    }"
                                    >Write goals for your clients</span
                                >
                                <span
                                    v-if="isStepDone('has_goals')"
                                    class="ml-auto small text-nowrap text-success font-weight-bold text-uppercase"
                                >
                                    <i class="fa fa-fw fa-check-circle text-success"></i>
                                    Done
                                </span>
                            </div>
                            <a
                                v-if="isStepDone('has_clients')"
                                href="/goals"
                                class="font-weight-bold text-primary"
                                >Write some goals ></a
                            >
                            <span v-else="" class="font-weight-bold text-light"
                                >Write some goals ></span
                            >
                        </div>
                    </div>

                    <div class="onboarding-list-item mx-1 mt-3 d-flex align-items-start">
                        <span class="badge badge-pill badge-dark mr-2">4</span>
                        <div class="w-100">
                            <div
                                class="w-100 font-weight-bold text-capitalize d-flex justify-content-between mb-0"
                            >
                                <span
                                    :class="{
                                        'text-light green-strike': isStepDone(
                                            'has_manual_trackers'
                                        ),
                                        'text-light': !isStepDone('has_goals'),
                                    }"
                                    >Add manual data to your goals</span
                                >
                                <span
                                    v-if="isStepDone('has_manual_trackers')"
                                    class="small ml-auto text-nowrap text-success font-weight-bold text-uppercase"
                                >
                                    <i class="fa fa-fw fa-check-circle text-success"></i>
                                    Done
                                </span>
                            </div>
                            <a
                                v-if="isStepDone('has_goals')"
                                href="/goals"
                                class="font-weight-bold text-primary"
                                >Enter data on the goal detail page ></a
                            >
                            <span v-else="" class="font-weight-bold text-light"
                                >Enter data on the goal detail page ></span
                            >
                        </div>
                    </div>

                    <div class="onboarding-list-item mx-1 mt-3 d-flex align-items-start">
                        <span class="badge badge-pill badge-dark mr-2">5</span>
                        <div class="w-100 mb-2">
                            <div
                                class="w-100 font-weight-bold text-capitalize d-flex  justify-content-between mb-0"
                            >
                                <span
                                    :class="{
                                        'text-light green-strike': isStepDone(
                                            'has_session_trackers'
                                        ),
                                        'text-light': !isStepDone('has_goals'),
                                    }"
                                    >Enter data in session</span
                                >
                                <span
                                    v-if="isStepDone('has_session_trackers')"
                                    class="small ml-auto text-nowrap text-success font-weight-bold text-uppercase"
                                >
                                    <i class="fa fa-fw fa-check-circle text-success"></i>
                                    Done
                                </span>
                            </div>
                            <a
                                v-if="isStepDone('has_goals')"
                                href="/data-tracker"
                                class="font-weight-bold text-primary"
                                >Try the data tracker ></a
                            >
                            <span v-else="" class="font-weight-bold text-light"
                                >Try the data tracker ></span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { helpers } from "../../plugins/helpers";

export default {
    name: "OnboardingChecklist",
    props: ["profileCompletion", "subscription"],
    data() {
        return {
            open: false,
            visible: false,
            profileCompletion_: {},
        };
    },
    created() {
        if (!["/billing"].includes(window.location.pathname)) {
            this.visible = true;
        }
        this.$bus.$on("profile-photo-changed", () => {
            if (_.get(this.profileCompletion_, "profile_status", false)) {
                this.profileCompletion_.profile_status.has_photo = true;
            }
        });
    },
    watch: {
        profileCompletion() {
            if (this.profileCompletion) {
                this.profileCompletion_ = { ...this.profileCompletion };
            }
        },
    },
    methods: {
        isStepDone(prop) {
            return (
                this.profileCompletion_ &&
                this.profileCompletion_.hasOwnProperty("profile_status") &&
                this.profileCompletion_.profile_status[prop]
            );
        },
        uploadPhoto() {
            const widget = document.getElementById("photo-widget");
            if (widget) {
                this.open = false;
                this.$bus.$emit("upload-photo");
            } else {
                helpers.goLink("/account-settings");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.onboarding-bg {
    right: 0;
    background: #ffcb6d;
    width: 300px;
    z-index: 2;
}
.onboarding-list-collapsed {
    transition: all 0.6s ease;
    height: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
}
.onboarding-close {
    top: 10px;
    right: 10px;
}
.onboarding-list-item:not(:last-child) {
    border-bottom: solid 1px #bfbfbf;
}
.badge {
    line-height: 1.5;
}
.green-strike {
    text-decoration-line: line-through;
    text-decoration-color: #28a745;
}
</style>
